'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
  CommunityMatrimonyServices,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';

const faqItems = [
  { question: 'Which the best Dnyandeep Vadhu Var Suchak Kendra in Maharashtra?', answer: 'In Maharashtra state, MarathiVadhuVarSuchak.com mobile Marathi matrimonial app is the most trusted Vadhu Var Suchak Kendra.' },
  { question: 'How to search Marathi Vadhu Var Suchak Kendra Photos with profile?', answer: 'To search Dnyandeep Vadhu Var Suchak Kendra Photos with profile, register free on MarathiVadhuVarSuchak.com matrimony.' },
  { question: 'What is the Marathi Vadhu Var Suchak Kendra Reviews?', answer: 'If you want to check Dnyandeep Vadhu Var Suchak Kendra Reviews, visit MarathiVadhuVarSuchak.com matrimony site.' },
  { question: 'How to search Marathi Vadhu Var Suchak Grooms profile?', answer: 'To search Dnyandeep Vadhu Var Suchak Groom, register through MarathiVadhuVarSuchak.com matrimony app.' },
  { question: 'How to search verified Marathi Vadhu Var profile?', answer: 'To search the Dnyandeep Vadhu Var Kendra profiles, visit Marathi matrimony site MarathiVadhuVarSuchak.com.' },
  { question: "How to search Maratha Vadhu Var Suchak bride's profile?", answer: 'To search the Dnyandeep Vadhu Var Suchak Bride profiles, you have to register free on MarathiVadhuVarSuchak.com site.' },
  { question: 'How to signup free on Marathi Vadhu Var Suchak matrimony site?', answer: 'For free Dnyandeep Vadhu Var Login, first register free through MarathiVadhuVarSuchak.com mobile app.' },
  { question: 'Which is the best Marathi Vadhu Var Suchak Kendra in Mumbai?', answer: 'Dnyandeep Vadhu Var Suchak Kendra Chunabhatti is the trusted choice to register free on MarathiVadhuVarSuchak.com mobile app.' },
  { question: 'Which is the Maratha Vadhu Var Suchak Mandal in Pune?', answer: 'Most trusted option is Dnyandeep Vadhu Var Suchak Mandal in Pune city. Visit MarathiVadhuVarSuchak.com portal for free registration.' },
  { question: 'How to register free on Marathi Vadhu Var Suchak Mandal?', answer: 'For Dnyandeep Vadhu Var Suchak Kendra Login, Marathi grooms and brides can register free on MarathiVadhuVarSuchak.com site.' },
  { question: 'How to search Marathi grooms online on matrimonial?', answer: 'To search Dnyandeep Vadhu Var Groom online, register free through trusted matrimonial app MarathiVadhuVarSuchak.com.' },
  { question: 'Which is the best Maratha Vadhu Var Suchak in Mumbai city?', answer: 'Most trusted Dnyandeep Vadhu Var Suchak Kendra Mumbai is MarathiVadhuVarSuchak.com portal.' },
  { question: 'Which is the best Vadhu Var Suchak in Satara city?', answer: 'Dnyandeep Vadhu Var Satara like MarathiVadhuVarSuchak.com is the well know matrimonial brand.' },
  { question: 'Which is the best matrimony in Satara region?', answer: 'Dnyandeep Vadhu Var Suchak Kendra Satara matrimonial site MarathiVadhuVarSuchak.com is the trusted brand.' },
  { question: 'Which is the best Marathi matrimony portal?', answer: 'www dnyandeep Vadhu Var Suchak com and MarathiVadhuVarSuchak.com are the trusted brand portal in Maharashtra.' },
  { question: 'Which the reputed Vadhu Var Suchak Kendra for Marathi grooms search?', answer: 'For Dnyandeep Vadhu Var Suchak Kendra Groom profile search, visit MarathiVadhuVarSuchak.com matrimony portal.' },
  { question: 'How to register free on best Marathi matrimonial site?', answer: 'Dnyandeep Vadhu Var Mandal and MarathiVadhuVarSuchak.com matrimony portal are best Marathi matrimonial site?' },
];

const communityServices: { label: string; href?: string }[] = [
  { label: "Dnyandeep Vadhu Var Suchak" },
  { label: "Dnyandeep Vadhu Var" },
  { label: "Dnyandeep Vadhu" },
  { label: "Dnyandeep Vadhu Var Suchak Kendra" },
  { label: "Dnyandeep Vadhu Var Suchak Kendra Photos" },
  { label: "Dnyandeep Vadhu Var Suchak Kendra Reviews" },
  { label: "Dnyandeep Vadhu Var Suchak Groom" },
  { label: "Dnyandeep Vadhu Var Kendra" },
  { label: "Dnyandeep Vadhu Var Suchak Bride" },
  { label: "Dnyandeep Vadhu Var Login" },
  { label: "Dnyandeep Vadhu Var Suchak Kendra Chunabhatti" },
  { label: "Dnyandeep Vadhu Var Suchak Mandal" },
  { label: "Dnyandeep Vadhu Var Suchak Kendra Login" },
  { label: "Dnyandeep Vadhu Var Groom" },
  { label: "Dnyandeep Vadhu Var Suchak Kendra Mumbai" },
  { label: "Dnyandeep Vadhu Var Satara" },
  { label: "Dnyandeep Vadhu Var Suchak Kendra Satara" },
  { label: "www dnyandeep Vadhu Var Suchak com" },
  { label: "Dnyandeep Vadhu Var Suchak Kendra Groom" },
  { label: "Dnyandeep Vadhu Var Mandal" },
];

export default function DnyandeepVadhuVarSuchakKendraClient() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      <Header variant="transparent" />

      <HomeHeroSection
        title="मराठी समाजातील वधू वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="dnyandeep_vadhu_var_suchak_kendra"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Frequently Asked Questions</h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {faqItems.map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">{faq.question}</h3>
                    <svg className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div className={`px-6 transition-all duration-300 ease-in-out ${openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'}`}>
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <CommunityMatrimonyServices
        title="Dnyandeep Vadhu Var Suchak Kendra for Marathi Communities"
        items={communityServices}
      />

    </div>
  );
}
